// extracted by mini-css-extract-plugin
module.exports = {"email":"styles_email__NLmqI"};